import React from "react";
import PropTypes from 'prop-types';
import {Modal, Row, Col, Popover, message, Slider, Form, Input, Select, Button, Table, Tag, List} from "antd";

import {getNodeDisplayTitle} from "@/constants/vis.defaultDefine.1";

import ViewDataProvider from "@/components/common/dataProvider/common.dataProvider.view";
import RelationshipClueDataProvider from '@/components/common/dataProvider/common.dataProvider.relationshipClue';
import {IconTypes} from '@/constants/common';
import Icon from "@/components/common/common.icon";

import style from "@/style/common/view/common.view.explore.less";
import {showErrorMessage} from "@/components/common/common.message";
import ExploreSmartRelationshipListsModal from '@/components/common/view/explore/common.view.explore.smartRelationshipListsModal';
import {Element as ScrollElement} from 'react-scroll';

import relationCluePng101 from '@/assets/clue/101.png';
import relationCluePng102 from '@/assets/clue/102.png';
import relationCluePng103 from '@/assets/clue/103.png';
import relationCluePng104 from '@/assets/clue/104.png';
import relationCluePng201 from '@/assets/clue/201.png';
import relationCluePng202 from '@/assets/clue/202.png';
import relationCluePng203 from '@/assets/clue/203.png';
import relationCluePng301 from '@/assets/clue/301.png';
import relationCluePng302 from '@/assets/clue/302.png';
import relationCluePng303 from '@/assets/clue/303.png';
import relationCluePng304 from '@/assets/clue/304.png';
import relationCluePng401 from '@/assets/clue/401.png';
import relationCluePng402 from '@/assets/clue/402.png';
import relationCluePng403 from '@/assets/clue/403.png';
import relationCluePng501 from '@/assets/clue/501.png';
import relationCluePng502 from '@/assets/clue/502.png';
import relationCluePng503 from '@/assets/clue/503.png';
import relationCluePng504 from '@/assets/clue/504.png';

const { TextArea } = Input;
/*
const xinSvg = () => (
  <svg width="22" height="22" fill="currentColor" viewBox="0 0 1024 1024">
    <path d="M512.398222 1024C122.140444 927.516444 64.455111 719.872 56.263111 650.467556 56.263111 650.467556 56.263111 83.683556 56.263111 83.683556 122.766222 83.683556 352.028444 0 512.398222 0 672.824889 0 902.030222 83.683556 967.736889 83.683556 967.736889 83.683556 967.736889 650.467556 967.736889 650.467556 959.715556 719.872 902.656 927.516444 512.398222 1024ZM912.327111 135.68C854.698667 135.68 653.312 62.122667 512.341333 62.122667 371.427556 62.122667 170.040889 135.68 111.559111 135.68 111.559111 135.68 111.559111 633.685333 111.559111 633.685333 118.727111 694.670222 169.415111 877.056 512.341333 961.820444 855.210667 877.056 905.329778 694.670222 912.327111 633.685333 912.327111 633.685333 912.327111 135.68 912.327111 135.68ZM394.581333 266.24C394.581333 266.24 540.615111 266.24 540.615111 266.24 540.615111 266.24 540.615111 222.435556 540.615111 222.435556 540.615111 222.435556 620.487111 222.435556 620.487111 222.435556 620.487111 222.435556 620.487111 266.24 620.487111 266.24 620.487111 266.24 768.796444 266.24 768.796444 266.24 768.796444 266.24 768.796444 314.709333 768.796444 314.709333 768.796444 314.709333 394.581333 314.709333 394.581333 314.709333 394.581333 314.709333 394.581333 266.24 394.581333 266.24ZM358.058667 750.705778C358.058667 750.705778 291.896889 750.705778 291.896889 750.705778 291.896889 750.705778 291.896889 409.258667 291.896889 409.258667 276.650667 418.474667 258.389333 426.951111 237.112889 434.631111 237.112889 434.631111 237.112889 388.551111 237.112889 388.551111 285.809778 353.109333 316.188444 297.813333 328.362667 222.435556 328.362667 222.435556 399.075556 222.435556 399.075556 222.435556 386.901333 274.716444 373.248 313.173333 358.058667 337.749333 358.058667 337.749333 358.058667 750.705778 358.058667 750.705778ZM741.376 406.983111C741.376 406.983111 417.393778 406.983111 417.393778 406.983111 417.393778 406.983111 417.393778 360.846222 417.393778 360.846222 417.393778 360.846222 741.376 360.846222 741.376 360.846222 741.376 360.846222 741.376 406.983111 741.376 406.983111ZM741.376 499.2C741.376 499.2 417.393778 499.2 417.393778 499.2 417.393778 499.2 417.393778 453.12 417.393778 453.12 417.393778 453.12 741.376 453.12 741.376 453.12 741.376 453.12 741.376 499.2 741.376 499.2ZM741.376 660.764444C742.855111 712.988444 717.824 738.360889 666.055111 736.824889 666.055111 736.824889 417.393778 736.824889 417.393778 736.824889 417.393778 736.824889 417.393778 550.001778 417.393778 550.001778 417.393778 550.001778 741.376 550.001778 741.376 550.001778 741.376 550.001778 741.376 660.764444 741.376 660.764444ZM672.995556 598.414222C672.995556 598.414222 485.831111 598.414222 485.831111 598.414222 485.831111 598.414222 485.831111 693.077333 485.831111 693.077333 485.831111 693.077333 643.299556 693.077333 643.299556 693.077333 663.04 693.077333 672.995556 682.268444 672.995556 660.764444 672.995556 660.764444 672.995556 598.414222 672.995556 598.414222Z" p-id="3061"
    ></path>
  </svg>
);
*/
const xinSvg = () => (
  <svg width="411" height="399" fill="currentColor" viewBox="0 0 1024 1024" overflow="hidden">
    <g clip-path="url(#clip0)" transform="translate(-2098 -818)"><path d="M2098 884.5 2166.5 818 2235 884.5 2200.75 884.5 2200.75 951 2132.25 951 2132.25 884.5Z"/></g>
  </svg>
);

const onChange = e => {
  console.log('Change:', e.target.value);
};

const { Option } = Select;

/*
const sliderMarks = {
  1: '不可信',
  2: '可能不可信',
  3: '不确定',
  4: '应该可信',
  5: '很可信'
};
*/
const sliderMarks = {
  1: '1',
  2: '2',
  3: '3',
  4: '4',
  5: '5'
};
/*
const confidenceColors = {
  1: '#ff0000',
  2: '#ff8800',
  3: '#facd14',
  4: '#88ff00',
  5: '#00ff00'
};
*/
const confidenceColors = {
  1: '#ff0000',
  2: '#843C0C',
  3: '#FFC000',
  4: '#4472C4',
  5: '#70AD47'
};

const relationText = {
  101: '完全相同',
  102: '大致相似',
  103: '总分包含',
  104: '非此即彼',
  201: '历史未来',
  202: '紧接连续',
  203: '同时发生',
  301: '东西左右',
  302: '南北上下',
  303: '内外包含',
  304: '相同地点',
  401: '因导致果',
  402: '转折对比',
  403: '条件假设',
  501: '并列称述',
  502: '多项选一',
  503: '程度递进',
  504: '连续发生',
}
const relationCluePng = {
  101: relationCluePng101,
  102: relationCluePng102,
  103: relationCluePng103,
  104: relationCluePng104,
  201: relationCluePng201,
  202: relationCluePng202,
  203: relationCluePng203,
  301: relationCluePng301,
  302: relationCluePng302,
  303: relationCluePng303,
  304: relationCluePng304,
  401: relationCluePng401,
  402: relationCluePng402,
  403: relationCluePng403,
  501: relationCluePng501,
  502: relationCluePng502,
  503: relationCluePng503,
  504: relationCluePng504,
}

const forRelation = tag => {
  const tagElem = (
    <Tag>
      {relationText[tag]}
    </Tag>
  );
  return (
    <span key={tag} style={{ display: 'inline-block' }}>
      {tagElem}
    </span>
  );
};


class ExploreSmartRelationshipCluesModal extends React.Component {
  state = {
    savingStatus: 'idle',
    graphToSave: [
      false,
      false,
      false,
    ],
    visibleRelationship:false,
    param_nodeClueId:'',
    param_url:'',
    param_text:'',
    param_urlConfidence:'4',
    param_textConfidence:'4',
    param_relations:[],
    RelationshipCluesList:[],
    visibleRelationshipCluesList:false,
    RelationshipCluesNum:0,
    containerId: `explore-company-overall-modal-${Math.random()}`,
    tooltipVisible: true
  };

  COLUMNS = (me) => [
    {
      title: '线索链接',
      dataIndex: 'url',
      key: 'url',
      width: '15rem',
      className: style['table-column'],
      render: (text, record) => {
        return (
          <div className={style['table-column-div']}>
            <Popover content={record.url}>
              <Icon component={xinSvg} style={{ color: confidenceColors[record.urlConfidence],width:'22px',height:'22px',overflow:'hidden',verticalAlign:'middle'}} />
              <span>{record.url}</span>
            </Popover>
          </div>
        );
      },
    },
    {
      title: '线索信息',
      dataIndex: 'text',
      key: 'text',
      width: '13rem',
      className: style['table-column'],
      render: (text, record) => (
        <div className={style['table-column-div']}>
          <Popover content={record.text}>
            <Icon component={xinSvg} style={{ color: confidenceColors[record.textConfidence],width:'22px',height:'22px',overflow:'hidden',verticalAlign:'middle'}}/>
            <span>{record.text}</span>
          </Popover>
        </div>
      ),
    },
    {
      title: '关系',
      dataIndex: 'relations',
      key: 'relations',
      width: '7rem',
      className: style['table-column'],
      render: (relations, record) => (
        <div style={{alignItems: 'left', cursor: 'pointer'}}>
          <Popover content={relations.map(forRelation)}>
            {relations.slice(0,3).map(forRelation)}
          </Popover>
        </div>
      ),
    },
    /*
    {
      title: '更新人',
      dataIndex: 'userId',
      key: 'userId',
      width: '4rem',
      className: style['member-table-column-amount'],
      render: (text, record) => (
        <div style={{display: 'flex', alignItems: 'left', cursor: 'pointer'}}>
            {me.props.memberMap && me.props.memberMap[`user-${record.userId}`]
                          ? me.props.memberMap[`user-${record.userId}`].nick : ('--')}
        </div>
      ),
    },
    {
      title: '更新时间',
      dataIndex: 'updateTimestamp',
      key: 'updateTimestamp',
      width: '9rem',
      className: style['member-table-column-amount'],
      render: (text, record) => (
        <div style={{display: 'flex', alignItems: 'left', cursor: 'pointer'}}>
            {text}
        </div>
      ),
    }
  */
  ];

  COLUMNS_SHOW = (me) => [
    {
      title: '操作',
      dataIndex: 'id',
      key: 'actions',
      className: style['table-column-actions'],
      width: '4rem',
      render: (id, record) => {
        return (
          <span>
          {
              record.userId == me.props.userId ? (
                <div><a onClick={() => me.onEditClue(record)}>编辑</a><br/>
                <a onClick={() => me.onRemoveClue(record.nodeClueId)}>删除</a></div>
              ) : null
          }
          </span>
        );
      },
    },
  ];
  onEditClue = (record) => {
    let me = this;
    me.setState({
      visibleRelationshipCluesList: false,
      param_nodeClueId:record.nodeClueId,
      param_url:record.url,
      param_text:record.text,
      param_urlConfidence:record.urlConfidence,
      param_textConfidence:record.textConfidence,
      param_relations:record.relations||[],
    });
    

  };
  onRemoveClue = (nodeClueId) => {
    let me = this;

    Modal.confirm({
      centered: true,
      title: "删除节点线索",
      icon: <Icon name="delete"/>,
      okText: "确认删除",
      okType: 'danger',
      cancelText: "取消",
      autoFocusButton: 'cancel',
      content: (<p>是否确认删除该节点线索？</p>),
      onOk: () => {
        RelationshipClueDataProvider.removeRelationshipClue(nodeClueId).then(config => {
          message.success('节点线索删除成功');
          me.showRelationshipCluesList();
        }).catch(error => {
          message.error('节点线索删除失败');
        });
      },
    });
  };

  afterModalClose = () => {
    this.setState({
      savingStatus: 'idle',
      graphToSave: [
        false,
        false,
        false,
      ],
    });
  };

  onSaveRelationshipClues = () => {
    let me = this, targetNodeId = me.props.targetNode.id;
    if(me.state.param_relations.length<1){
      message.error('这个线索跟所选节点的关系');
      return;
    }
    let param = {
      "viewId": me.props.viewDataProvider.viewId,
      "nodeId": targetNodeId,
      "url": me.state.param_url,
      "text": me.state.param_text,
      "urlConfidence": me.state.param_urlConfidence,
      "textConfidence": me.state.param_textConfidence,
      "relations": me.state.param_relations
    }
    me.setState({savingStatus: 'processing'}, () => {
      if(me.state.param_nodeClueId!=''){
        RelationshipClueDataProvider.updateRelationshipClue(me.state.param_nodeClueId,param).then(() => {
          message.success('保存成功');
          me.setState({savingStatus: 'succeeded'}, () => {
            me.showRelationshipCluesList();
          });
        }).catch(error => {
          message.error('保存失败');
          me.setState({savingStatus: 'failed'});
        });
      }else{
        RelationshipClueDataProvider.addRelationshipClue(param).then(() => {
          message.success('保存成功');
          me.setState({savingStatus: 'succeeded'}, () => {
            me.showRelationshipCluesList();
          });
        }).catch(error => {
          message.error('保存失败');
          me.setState({savingStatus: 'failed'});
        });
      }
    });
  };

  showRelationshipCluesList = () => {
    let me = this;
    me.setState({visibleRelationshipCluesList: true});
    me.getRelationshipCluesList();
  };

  getRelationshipCluesList = () => {
    let me = this, targetNodeId = me.props.targetNode && me.props.targetNode.id;
    let param = {
      "view_id": me.props.viewDataProvider.viewId,
      "node_id": targetNodeId,
      start: 0,
      limit: 10000
    }
    targetNodeId && RelationshipClueDataProvider.loadRelationshipClueList(param).then(data => {
      me.setState({RelationshipCluesList: data.data,RelationshipCluesNum:data.total});
    }).catch(error => {
      message.error('获取数据失败');
    });
  };

  gotoBack = () =>{
    this.setState({
      visibleRelationshipCluesList: false,
      RelationshipCluesList: [],
      RelationshipCluesNum: 0,
      param_nodeClueId:'',
      param_url:'',
      param_text:'',
      param_urlConfidence:'',
      param_textConfidence:'',
      param_relations:[],
    });
  }

  tipFormatter = (value) =>{
    const tipTxt = ['','不可信','可能不可信','不确定','基本可信','非常可信'];
    return tipTxt[value];
  }
  
  componentDidMount() {
    let me = this;
    me.getRelationshipCluesList();
  }

  componentWillUnmount() {
    let me = this;
    me.setState({
      visibleRelationshipCluesList: false,
      RelationshipCluesList: [],
      RelationshipCluesNum: 0
    });
  }

  render() {
    let me = this;
    const no_relations =['','',''];
    let nodeTitle = me.props.targetNode ? `${getNodeDisplayTitle(me.props.targetNode, 200)}` : '';
    let modalTitle = me.state.visibleRelationshipCluesList?(<Row><Col span={18}>节点线索列表(<Popover content={nodeTitle} placement={'bottom'}><span className={style['relation-note-title']}>{nodeTitle}</span></Popover>)</Col><Col span={5} offset={1} onClick={() =>{me.gotoBack()}} style={{color:'#1890ff'}}> ＜返回</Col></Row>):
      (<Row><Col span={18}>为节点提供线索　(<Popover content={nodeTitle} placement={'bottom'}><span className={style['relation-note-title']}>{nodeTitle}</span></Popover>)</Col><Col span={5} offset={1} onClick={() =>{me.showRelationshipCluesList()}} style={{color:'#1890ff'}}>
        已有{me.state.RelationshipCluesNum||0}条
        </Col></Row>);
    return (
      <Modal
        title={modalTitle}
        visible={me.props.visible}
        onCancel={me.props.onClose}
        afterClose={me.afterModalClose}
        closable={me.state.savingStatus !== 'processing'}
        width={`calc(40rem + 48px)`}
        max-height={`calc(55rem)`}
        centered={true}
        cancelText={'取消'}
        okText={'保存'}
        okButtonProps={{
          loading: me.state.savingStatus === 'processing',
        }}
        destroyOnClose={true}
        onOk={me.onSaveRelationshipClues}
        wrapClassName={style['view-transfer-modal']}
        className={`${style['relationshiplist-box']}`}
      >
        <ScrollElement
          id={me.state.containerId}
          className={`scrollbar-none scrollbar`}
          style={{overflow: 'hidden auto', maxHeight: '43rem'}}
          onScroll={e => {
            let element = e.target;
            me.autoScroll = element.scrollHeight - element.scrollTop - element.clientHeight < 10;
          }}
        >
        {!me.state.visibleRelationshipCluesList && <Form layout={'vertical'} onSubmit={me.onSaveConfig} className={style['config-edit-form']}>
          <Row gutter={24}>
              <Col span={24} key={1}>
                <Form.Item label={
                  <Row justify="space-between" align="bottom">
                    <Col span={15} style={{paddingTop:'10px',fontSize:'16px',fontWeight:'bold'}}>
                      <Icon component={xinSvg} style={{ color: confidenceColors[me.state.param_urlConfidence||0],width:'66px',height:'66px',overflow:'hidden',verticalAlign:'middle'}} /> 线索链接
                      <span style={{color:'rgba(0,0,0,.45)',fontWeight:'normal'}}> (请输入网页地址)</span>
                    </Col>
                    <Col span={2} style={{ paddingTop:'10px',height:'66px',lineHeight:'66px',color:'rgba(0,0,0,.45)'}}>
                      <span>
                        可信度
                      </span>
                    </Col>
                    <Col span={7} style={{height:'66px',paddingTop:'30px'}}>
                      <Slider marks={sliderMarks} included={false} defaultValue={me.state.param_urlConfidence||4} onChange={value => me.setState({param_urlConfidence: value})} min={1} max={5} tipFormatter={this.tipFormatter} tooltipVisible={me.state.tooltipVisible} style={{height:'30px',margin:'5px 10px'}}/>
                    </Col>
                  </Row>}
                  rules={[{required: true},{type: 'url',message: '请输入URL',},{type: 'string',min: 6,message: '请输入URL'}]}
                >
                  <Input style={{width:'90%'}} defaultValue={me.state.param_url||"http://"} onChange={e => me.setState({param_url: e.target.value})} />
                </Form.Item>
              </Col>
          </Row>
          <Row gutter={24}>
              <Col span={24} key={3}>
                <Form.Item style={{marginBottom:'0'}} label={
                  <Row justify="space-between" align="bottom">
                    <Col span={15} style={{paddingTop:'10px',fontSize:'16px',fontWeight:'bold'}}>
                      <Icon component={xinSvg} style={{ color: confidenceColors[me.state.param_textConfidence||0],width:'66px',height:'66px',overflow:'hidden',verticalAlign:'middle'}} /> 线索信息
                      <span style={{color:'rgba(0,0,0,.45)',fontWeight:'normal'}}> (请输入一段文本)</span>
                    </Col>
                    <Col span={2} style={{ paddingTop:'10px',height:'66px',lineHeight:'66px',color:'rgba(0,0,0,.45)'}}>
                      <span>
                        可信度
                      </span>
                    </Col>
                    <Col span={7} style={{height:'66px',paddingTop:'30px'}} className={style['relationship-slider']}>
                      <Slider marks={sliderMarks} included={false} defaultValue={me.state.param_textConfidence||4} onChange={value => me.setState({param_textConfidence: value})} min={1} max={5} tipFormatter={this.tipFormatter} tooltipVisible={me.state.tooltipVisible} style={{height:'30px',margin:'5px 10px'}}/>
                    </Col>
                  </Row>
                  }
                  rules={[
                    {
                      required: true,
                      message: '请输入线索信息',
                    },
                  ]}
                 >
                  <TextArea style={{width:'90%'}} defaultValue={me.state.param_text||''} onChange={e => me.setState({param_text: e.target.value})} autoSize={{ minRows: 5, maxRows: 8 }} placeholder={'请输入一个网页上的重点句子或段落等线索信息'} />
                </Form.Item>
                </Col>
              </Row>
            <Form.Item className={style['relationship-item']} style={{margin:'0'}} label={
              <Row justify="space-between" align="bottom">
                <Col span={24} style={{paddingTop:'5px',fontSize:'16px',fontWeight:'bold'}}>
                  <span>
                    <Icon style={{fontSize:'60px',verticalAlign:'middle'}} color="#3498DB" type={IconTypes.ICON_FONT} name="icon-relative-graph"/> <span style={{fontSize:'16px',fontWeight:'bold'}}> 线索关系</span>
                    <span style={{color:'rgba(0,0,0,.45)',fontWeight:'normal',marginRight:'30px'}}> (请选择与节点的关系)</span>
                    <Button onClick={()=>me.setState({visibleRelationship: 'true',tooltipVisible:false})} type="primary" icon={'folder-add'} shape="round" ghost>选择关系</Button>
                  </span>
                </Col>
              </Row>
            }>
              <div style={{marginLeft:'72px'}}>
              {me.state.param_relations && me.state.param_relations.length>0 && <List
                  grid={{ gutter: 16, column: 4 }}
                  dataSource={me.state.param_relations}
                  renderItem={item => (
                    <List.Item>
                      <div className={`${style['relation-svg-box']} ${style['relation-checkod-box']}`}>
                        <div><img src={relationCluePng[item]}/></div>
                        <div>{relationText[item]}</div>
                      </div>
                    </List.Item>
                  )}
                />} 
                {!me.state.param_relations || me.state.param_relations.length==0 && <List
                  grid={{ gutter: 16, column: 4 }}
                  dataSource={no_relations}
                  renderItem={item => (
                    <List.Item>
                      <div className={`${style['relation-svg-box']} ${style['relation-dashed-box']}`}>
                         
                      </div>
                    </List.Item>
                  )}
                />} 
              </div>
            </Form.Item>
          <div className="clearfix"></div>
				</Form>}
        {me.state.visibleRelationshipCluesList && <Table
              className={`${style['member-table']} scrollbar-none`}
              columns={me.COLUMNS(me).concat(me.COLUMNS_SHOW(me))}
              dataSource={me.state.RelationshipCluesList}
              pagination={false}
              rowKey={'id'}
              size="small"
        />}
        {me.state.visibleRelationship && <ExploreSmartRelationshipListsModal
          visible={me.state.visibleRelationship}
          relations={me.state.param_relations}
          onClose={() => me.setState({visibleRelationship: false,tooltipVisible:true})}
          onChoose={(val) => me.setState({param_relations: val})}
        />}
        </ScrollElement>
      </Modal>
    );
  }
}

ExploreSmartRelationshipCluesModal.propTypes = {
  targetNode: PropTypes.object,
  graphList: PropTypes.array.isRequired,
  viewDataProvider: PropTypes.instanceOf(ViewDataProvider).isRequired,
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ExploreSmartRelationshipCluesModal;